import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DialogComponent, DialogService } from "ngx-bootstrap-modal";
import { CommonConst } from '../shared/const/common-const';
import { N407SessionStorageKey } from './n407-session-storage-key';
import { N4074MainData } from './n4074-main-data';
import { N4074OutputData } from './n4074-output-data';
import { MessageUtil } from '../shared/utility/message-util';
import { RedirectUtil } from '../shared/utility/redirect-util';
import { isNullOrUndefined } from 'util';
import { CommonStorageKey } from '../shared';
declare var $: any;

@Component({
  selector: 'app-n4074',
  templateUrl: './n4074.component.html',
  styleUrls: ['./n4074.component.css']
})
export class N4074Component extends DialogComponent<null, boolean> implements OnInit, OnDestroy {
  @ViewChild('buttonSelect') buttonSelect: ElementRef;
  elementId: any;
  public isLoading: boolean;
  
  public outputData = new N4074OutputData();
  public detailData: N4074MainData[];
  public inputData = new N4074MainData();
  public detailCount: number;

  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router) {
    super(dialogService);
  }

  // 初期表示
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    // Ｗｅｂサーバへコントローラ処理(初期表示)の実行を要求する。
    document.body.style.cursor = 'wait';
    this.inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N4074OutputData>('/InitialN4074', this.inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }
      this.outputData = result[0];
      switch (this.outputData.rtnCode) {
        case CommonConst.C_RTN_CODE_OK:
          // 配送ルートリスト
          this.detailData = this.outputData.detailData;
          this.detailCount = this.detailData.length;
          let inputCode = sessionStorage.getItem(N407SessionStorageKey.N4074KOKAITAISHOHIDDEN);
          if (!isNullOrUndefined(inputCode)) {
            for (let i = 0; i < this.detailData.length; i++) {
              if (inputCode.indexOf(this.detailData[i].gurupuKubun) > -1) {
                this.detailData[i].flg = true;
              }
            }
            sessionStorage.removeItem(N407SessionStorageKey.N4074KOKAITAISHOHIDDEN);
          }
          setTimeout(() => {
            document.getElementById('checkFlg0').focus();
          }, 10);
          break;
        case CommonConst.C_RTN_CODE_NG:
          this.messageInfo.setMsg(MessageUtil.getStorageMessage(this.outputData.messageId));
          break;
        case CommonConst.C_RTN_CODE_API_NG3:
        case CommonConst.C_RTN_CODE_API_NG4:
          this.messageInfo.setMsg(this.outputData.messejiHombun);
          break;
        default:
          this.router.navigateByUrl('/ne01', { skipLocationChange: true }); // 強化テストNo146
          break;
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; }); // 強化テストNo146

    

  }

  // 選択ボタン押下
  btnSelect() {
    let kokaiTaisho = '';
    let kokaiTaishoHidden = '';
    for (let i = 0; i < this.detailData.length; i++) {
      const checkFlg = <HTMLInputElement>document.getElementById('checkFlg' + i);
      if (checkFlg.checked) {
        kokaiTaisho = kokaiTaisho + this.detailData[i].gurupuKubunMei + ',';
        kokaiTaishoHidden = kokaiTaishoHidden + this.detailData[i].gurupuKubun + ',';
      }
    }
    if (kokaiTaisho.endsWith(',')) {
      kokaiTaisho = kokaiTaisho.substr(0, kokaiTaisho.length - 1);
      var reg = new RegExp(',', 'g');
      kokaiTaisho = kokaiTaisho.replace(reg, '、');
    }
    //引用元画面は4071の場合
    if (sessionStorage.getItem(N407SessionStorageKey.N4074MOTOFLG) == '4071') {
      sessionStorage.setItem(N407SessionStorageKey.N4071KOKAITAISHO, kokaiTaisho);
      sessionStorage.setItem(N407SessionStorageKey.N4071KOKAITAISHOHIDDEN, (kokaiTaishoHidden.substr(0, kokaiTaishoHidden.length - 1)));
    } else {
      sessionStorage.setItem(N407SessionStorageKey.N4072KOKAITAISHOMAIN, kokaiTaisho);
      sessionStorage.setItem(N407SessionStorageKey.N4072KOKAITAISHOHIDDENMAIN, (kokaiTaishoHidden.substr(0, kokaiTaishoHidden.length - 1)));
    }    
    this.close(true);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    sessionStorage.removeItem(N407SessionStorageKey.N4074MOTOFLG);
    sessionStorage.removeItem(N407SessionStorageKey.N4074KOKAITAISHO);
    sessionStorage.removeItem(N407SessionStorageKey.N4074KOKAITAISHOHIDDEN);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {

    // Tabキーおよび十字キーの場合
    if (event.keyCode == 9 && !event.shiftKey) {
      // 選択ボタンにフォーカス設定
      if (document.activeElement.id == 'buttonSelect' || document.activeElement.id == '') {
        document.getElementById('checkFlg0').focus();
        return false;
      }
    }
    // 十字キー(←↑)の場合
    if (event.keyCode == 37 || event.keyCode == 38 || (event.keyCode == 9 && event.shiftKey)) { // 強化テストNo216
      if (document.activeElement.id == 'checkFlg0' || document.activeElement.id == '') {
        document.getElementById('buttonSelect').focus();
      } else if (document.activeElement.id == 'buttonSelect') {
        let id = 'checkFlg' + (this.detailCount - 1);
        document.getElementById(id).focus();
      } else {
        let id = 'checkFlg' + (parseInt(document.activeElement.id.substr(8, 1)) - 1);
        document.getElementById(id).focus();
      }
      return false;
    }
    // 十字キー(→↓)場合
    if (event.keyCode == 39 || event.keyCode == 40) {
      if (document.activeElement.id == 'buttonSelect' || document.activeElement.id == '') {
        document.getElementById('checkFlg0').focus();
      } else if (document.activeElement.id.substr(8, 1) == (this.detailCount - 1).toString()) {
        document.getElementById('buttonSelect').focus();
      } else {
        let id = 'checkFlg' + (parseInt(document.activeElement.id.substr(8, 1)) + 1);
        document.getElementById(id).focus();
      }
      return false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/n407/n4074.component.ts